import {
  CalendarNav,
  CalendarNext,
  CalendarPrev,
  CalendarToday,
  Eventcalendar,
  SegmentedGroup,
  SegmentedItem,
  setOptions,
} from "@mobiscroll/react5";
import { isMobileOnly } from "react-device-detect";
import { useHistory } from "react-router-dom";

import React, { useCallback, useState } from "react";
import Loader from "src/components/Dashboard/common/Loader";
import calendar from "../../../assets/calendar.svg";
import "../Schedule/schedule.scss";
import "./Calendar.scss";
import { getActivePolicies } from "./api";
import StatusBookedModal from "./statusBooked/StatusBookedModal";
import StatusClosedModal from "./statusClosed/StatusClosedModal";
import StatusOpenModal from "./statusOpen/StatusOpenModal";

import { Card } from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { BsInfoCircleFill } from "react-icons/bs";

import { useDispatch, useSelector } from "react-redux";
import { changeCurrentDay, updateConsultationType } from "src/features/timeslots/timeslotsSlice";
import { convertToTimezone, toISOString } from "src/lib/dateUtils";

setOptions({ theme: "ios", themeVariant: "light", });
// const initialPolicies = { Emergency: false, Face2Face: false, Online: false, };

function Calendar() {

  const dispatch = useDispatch();
  const history = useHistory();
  const [view, setView] = React.useState("day");
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenClosedModal, setIsOpenClosedModal] = useState(false);
  const [isOpenBookedModal, setIsOpenBookedModal] = useState(false);
  const [data, setData] = useState({});
  const [loader, setLoader] = useState(false);
  const [calView, setCalView] = useState({
    schedule: {
      type: "day",
      timeCellStep: 15,
      dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    },
  });

  //fetch timeSlots from redux store
  const timeSlots = useSelector(state => state.timeslots?.listTimeSlots);

  const openModal = () => { setIsOpen(true); };
  const closeModal = () => { setIsOpen(false); };
  const openBookedModal = () => { setIsOpenBookedModal(true); };
  const openClosedModal = () => { setIsOpenClosedModal(true); };
  const closeClosedModal = () => { setIsOpenClosedModal(false); };
  const closeBookedModal = () => { setIsOpenBookedModal(false); };

  const onEventClick = React.useCallback((event) => {
    let currentEvent = event.event;
    setData(currentEvent);

    if (currentEvent.status === "Active") {
      openModal();
    } else if (currentEvent.status === "Closed") {
      openClosedModal();
    } else {
      if (isMobileOnly) {
        const LINK = `/patient-record/${currentEvent.patient.id}?appointmentId=${currentEvent.appointmentId}`;
        history.push(LINK);
      } else openBookedModal();
    }
    // }
  }, []);

  React.useEffect(() => {

    const fetchPolicies = async () => {
      const res = await getActivePolicies();
      const policies = res?.doctorProfile.policy;

      if (policies == null) return { consultationType: {}, cashAccepted: false };

      const consultationType = Object.keys(policies)
        .filter((type) => policies[type]?.status === "Active" && type !== "Emergency")
        .map((type) => ({ text: type === "Face2Face" ? "In person at clinic" : type, value: type, }));

      const cashAccepted = policies?.Face2Face?.cashPaymentAccepted ? true : false;
      const emergency = policies.Emergency?.status === "Active" ? true : false;

      dispatch(updateConsultationType({ consultationType, cashAccepted, emergency }));
    };

    fetchPolicies();
  }, []);

  const changeView = (event) => {
    let calView;

    switch (event.target.value) {
      case "month":
        calView = { calendar: { labels: true }, };
        break;
      case "week":
        calView = { schedule: { type: "week", timeCellStep: 15 }, };
        break;
      case "day":
        calView = { schedule: { type: "day", timeCellStep: 15 }, };
        break;
    }

    setView(event.target.value);
    setCalView(calView);
  };

  const customWithNavButtons = () => {
    return (
      <React.Fragment>
        <Card.Header className="d-flex justify-content-between customCardHeader w-100">
          <Card.Title className="customCardTitle">
            <img style={{ maxWidth: "20px", maxHeight: "20px" }} src={calendar} className="mr-2" alt="" />
            {" "}Calendar &nbsp;
            <OverlayTrigger
              key="bottom"
              placement="bottom"
              overlay={
                <Tooltip id="tooltip-bottom">
                  <p className="d-flex align-items-center justify-content-start">
                    <span style={{ background: "#1aab73", width: "10px", height: "20px", }}>
                      &nbsp; &nbsp;
                    </span>{" "}
                    - Active Slot
                  </p>
                  <p className="d-flex align-items-center justify-content-start">
                    <span style={{ background: "#d88146", width: "10px", height: "20px", }}>
                      &nbsp; &nbsp;
                    </span>{" "}
                    - Pre Booked Slot
                  </p>
                  <p className="d-flex align-items-center justify-content-start">
                    <span style={{ background: "#c06c84", width: "10px", height: "20px", }}>
                      &nbsp; &nbsp;
                    </span>{" "}
                    - Booked Slot
                  </p>
                  <p className="d-flex align-items-center justify-content-start">
                    <span style={{ background: "#757575", width: "10px", height: "20px", }}>
                      &nbsp; &nbsp;
                    </span>{" "}
                    - Closed Slot
                  </p>
                </Tooltip>
              }
            >
              <BsInfoCircleFill />
            </OverlayTrigger>
          </Card.Title>
          <div className="cal-header-picker d-flex align-items-center">
            <CalendarNav className="cal-header-nav" />
            <SegmentedGroup className="cal-header-view" value={view} onChange={changeView} >
              <SegmentedItem value="day">Day</SegmentedItem>
              <SegmentedItem value="week">Week</SegmentedItem>
              <SegmentedItem value="month">Month</SegmentedItem>
            </SegmentedGroup>
          </div>
          <div className="">
            <CalendarPrev className="cal-header-prev" />
            <CalendarToday className="cal-header-today" />
            <CalendarNext className="cal-header-next" />
          </div>
        </Card.Header>
      </React.Fragment>
    );
  };

  const renderScheduleEvent = useCallback((data) => {
    let color = "#757575";
    if (data.original.status === "Active") {
      color = "#1aab73";
    } else if (data.original.status === "PreBooked") {
      color = "#d88146";
    } else if (data.original.status === "Booked") {
      color = "#c06c84 ";
    } else {
      color = "#757575";
    }

    return (
      <div className="docg-custom-schedule-event d-flex" style={{ background: color, color: "#fff", }} >
        <div className="docg-custom-event">{data?.original?.description}</div>
        <div className="docg-custom-event-time">
          {data?.original?.status.toLowerCase() === "prebooked" ||
            data?.original?.status.toLowerCase() === "booked" ? (
            <>
              {data?.original?.patient?.firstName}{" "}
              {data?.original.patient?.lastName}{" "}
              <span>
                {data.start} to {data.end}
              </span>
            </>
          ) : (
            `${data.start} to ${data.end}`
          )}
        </div>
      </div>
    );
  });

  const renderLabel = useCallback((data) => {
    let color = "#757575";
    if (data.original.status === "Active") {
      color = "#1aab73";
    } else if (data.original.status === "PreBooked") {
      color = "#d88146";
    } else if (data.original.status === "Booked") {
      color = "#c06c84 ";
    } else {
      color = "#757575";
    }

    return (
      <div className="docg-custom-schedule-event d-flex" style={{ background: color, color: "#fff", }} >
        <div className="docg-custom-event">{data?.original?.description}</div>
        <div className="docg-custom-event-time">
          {data?.original?.status.toLowerCase() === "prebooked" ||
            data?.original?.status.toLowerCase() === "booked" ? (
            <>
              {data?.original?.patient?.firstName}{" "}
              {data?.original.patient?.lastName}
            </>
          ) : (
            `${data.start} to ${data.end}`
          )}
        </div>
      </div>
    );
  });

  async function onPageLoading(event, inst) {
    const start = toISOString(event.firstDay)
    const end = toISOString(event.lastDay)
    dispatch(changeCurrentDay({ start, end }));
  }

  const updatedTimeSlots = timeSlots.map(slot => ({
    ...slot,
    start: convertToTimezone(slot.start),
    end: convertToTimezone(slot.end),
  }));

  return (
    <>
      <Loader show={loader} />
      <Card className="docg-schedule-card w-auto m-0">
        <Eventcalendar
          renderHeader={customWithNavButtons}
          renderScheduleEvent={renderScheduleEvent}
          displayTimezone="local"
          // timezonePlugin={dayjsTimezone}
          timezone="utc"
          renderLabel={renderLabel}
          renderEventContent={renderLabel}
          clickToCreate={false}
          dragToCreate={false}
          dragToMove={false}
          dragToResize={false}
          data={updatedTimeSlots}
          view={calView}
          onEventClick={onEventClick}
          cssClass="md-switching-view-cont"
          onPageLoading={onPageLoading}
        />
      </Card>
      <StatusOpenModal isOpen={isOpen} closeModal={closeModal} data={data} />
      <StatusClosedModal isOpen={isOpenClosedModal} closeModal={closeClosedModal} data={data} />
      <StatusBookedModal isOpen={isOpenBookedModal} closeModal={closeBookedModal} data={data} />
    </>
  );
}

export default Calendar;